import { render, staticRenderFns } from "./unit-of-measure.vue?vue&type=template&id=29d3fb0c&"
import script from "./unit-of-measure.vue?vue&type=script&lang=js&"
export * from "./unit-of-measure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports